import {restfulClient} from "@/api";
import {cloneDeep} from "lodash";

const giftCategoryUrl = '/gift/gift-categories'
const giftUrl = '/gift/gifts'
const giftStockUrl = '/gift/gift-stocks'
export const exportStockUrl = 'gift/gift-stock-excel'
export const templateUrl = 'gift/gift-stock-template'

export function getCategory() {
    return restfulClient.getAll(giftCategoryUrl)
}

export function getGiftList(searchForm) {
    let queryParams = cloneDeep(searchForm)
    if (searchForm?.query.title) queryParams.query.title = `%${searchForm.query.title}%`
    return restfulClient.getCollection(giftUrl, {
        ...queryParams,
        withRels: ['stock']
    })
}

export function delGift(id) {
    return restfulClient.remove(giftUrl, id)
}

export function createGift(form) {
    return restfulClient.create(giftUrl, form)
}

export function giftDocument(id) {
    return restfulClient.getDocument(giftUrl, id)
}

export function updateGift(form) {
    const id = form.id
    delete form.id
    return restfulClient.update(giftUrl, id, form)
}

export function getStockList(searchForm) {
    let query = {}
    let relsQuery = {}
    if (searchForm.query.content) {
        if (searchForm.query.field === 'code') {
            query.code = `%${searchForm.query.content}%`
        }

        if (searchForm.query.field === 'title') {
            relsQuery = {
                gift: {title: `%${searchForm.query.content}%`}
            }
        }
    }

    return restfulClient.getCollection(giftStockUrl, {
        query,
        relsQuery,
        pagination: searchForm.pagination,
        withRels: ['gift'],
    })
}

export function updateStock(row) {
    const id = row.id
    return restfulClient.update(giftStockUrl, id, {stock: row.stock})
}